export default "__VITE_ASSET__C6TpzUL4__"